import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Active une étape'.
 */
export class ActivateStepActionData extends BaseActionData {
    /**
     * Id de l'étape à activer.
     */
    public stepId: number;

    /**
     * Id de l'état que doit prendre l'étape.
     */
    public stateId: number;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.ActivateStep);
    }

    /**
     * Retourne une copie d'une instance de ActivateStepActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: ActivateStepActionData) {
        if (!!other) {
            const instance = new ActivateStepActionData();
            instance.stepId = other.stepId;
            instance.stateId = other.stateId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
